import { Avatar, Grid, Stack, Typography } from '@mui/material';
import { IEquipmentPrevOrder } from 'API';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { BigButton } from 'Images';
import { useState } from 'react';
import { OrderStatusDialog } from '../../OrderStatusDialog';
import { OrderCard } from './OrderCard';

interface IOrderListMobile {
  recentOrders: IEquipmentPrevOrder[];
}

export const OrderListMobile = ({ recentOrders }: IOrderListMobile) => {
  const maxOrdersCount = 5;
  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  const [openDialog, setOpenDialog] = useState(false);
  const [selectedValue, setSelectedValue] = useState<IEquipmentPrevOrder>();
  const [showAllOrders, setShowAllOrders] = useState(false);

  const handleOpenModal = (p: IEquipmentPrevOrder) => {
    setSelectedValue(p);
    setOpenDialog(true);
  };
  const handleClose = () => {
    setSelectedValue(undefined);
    setOpenDialog(false);
  };

  const gridTitles = [
    dictionary.RecentOrders.date,
    dictionary.RecentOrders.orderId,
    dictionary.RecentOrders.productsCount,
    dictionary.RecentOrders.status,
  ];

  const getFilteredOrders = () => {
    if (recentOrders.length <= maxOrdersCount) return recentOrders;
    return recentOrders?.slice(
      0,
      showAllOrders ? recentOrders.length : maxOrdersCount
    );
  };

  return (
    <>
      <Grid container rowSpacing={0} columnSpacing={0} mb={1}>
        <Grid component={'ul'} container item sx={{ padding: 0 }}>
          {getFilteredOrders().map((order, index) => (
            <OrderCard
              titles={gridTitles}
              key={index}
              item={order}
              onShowOrderDetailsClick={() => handleOpenModal(order)}
            />
          ))}
          {recentOrders.length > maxOrdersCount && !showAllOrders && (
            <Stack
              onKeyUp={(e: React.KeyboardEvent) => {
                e.key === 'Enter' && setShowAllOrders(true);
              }}
              tabIndex={0}
              onClick={() => setShowAllOrders(true)}
              direction={'row'}
              spacing={1}
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                m: '10px 50px',
              }}
            >
              <Typography variant='body5' color={'primary'}>
                {dictionary.RecentOrders.showMoreOrders}
              </Typography>
              <Avatar
                src={BigButton}
                alt=''
                sx={{
                  width: '46px',
                  height: '50px',
                  transform: 'rotate(270deg)',
                }}
              />
            </Stack>
          )}
        </Grid>
      </Grid>
      {openDialog && selectedValue && (
        <OrderStatusDialog
          onClose={handleClose}
          open={openDialog}
          item={selectedValue}
        />
      )}
    </>
  );
};
